// lib/format.ts
export function formatJpDateTime(iso?: string) {
  if (!iso) return '';
  const d = new Date(iso);
  // タイムゾーンが重要なら dayjs/tz 等に差し替え可
  const y = d.getFullYear();
  const m = `${d.getMonth() + 1}`.padStart(2, '0');
  const day = `${d.getDate()}`.padStart(2, '0');
  const hh = `${d.getHours()}`.padStart(2, '0');
  const mm = `${d.getMinutes()}`.padStart(2, '0');
  return `${y}/${m}/${day} ${hh}:${mm}`;
}
